module.exports={
	"Form": "SampleCreateManifest",
	"Scope": "Sample-Create",
	"Descriptors":
	{
		"SampleDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Sample-Create-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Sample-Create-Identity",
				"Group": "Sample-Create-Identity"
			}
		},
		"SampleDetails.Name":
		{
			"Name": "Name",
			"Hash": "Sample-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Sample-Create-Identity",
				"Group": "Sample-Create-Identity"
			}
		},
		"SampleDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Sample-Create-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Sample-Create-Identity",
				"Group": "Sample-Create-Identity"
			}
		},
		"SampleDetails.DesignatedTime":
		{
			"Name": "Designated Time",
			"Hash": "Sample-Create-DesignatedTime",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.CaptureLatitude":
		{
			"Name": "Capture Latitude",
			"Hash": "Sample-Create-CaptureLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.CaptureLongitude":
		{
			"Name": "Capture Longitude",
			"Hash": "Sample-Create-CaptureLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "Sample-Create-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"SampleDetails.ParentIDSample":
		{
			"Name": "Parent Sample",
			"Hash": "Sample-Create-ParentIDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				]
			}
		},
		"SampleDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Sample-Create-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"SampleDetails.IDProductionPlant":
		{
			"Name": "Production Plant",
			"Hash": "Sample-Create-IDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "ProductionPlant",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"SampleDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "Sample-Create-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"SampleDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Sample-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 12,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Status":
		{
			"Name": "Status",
			"Hash": "Sample-Create-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.LabControlNumber":
		{
			"Name": "Lab Control Number",
			"Hash": "Sample-Create-LabControlNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.LabReferenceNumber":
		{
			"Name": "Lab Reference Number",
			"Hash": "Sample-Create-LabReferenceNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.ProductName":
		{
			"Name": "Product Name",
			"Hash": "Sample-Create-ProductName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "Sample-Create-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Sample-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"SampleDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Sample-Create-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				]
			}
		},
		"SampleDetails.IntendedUse":
		{
			"Name": "Intended Use",
			"Hash": "Sample-Create-IntendedUse",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.BuyUSA":
		{
			"Name": "Buy USA",
			"Hash": "Sample-Create-BuyUSA",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "9",
				"Width": 3,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.ReceivedFrom":
		{
			"Name": "Received From",
			"Hash": "Sample-Create-ReceivedFrom",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.GeographicalArea":
		{
			"Name": "Geographical Area",
			"Hash": "Sample-Create-GeographicalArea",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Station":
		{
			"Name": "Station",
			"Hash": "Sample-Create-Station",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Offset":
		{
			"Name": "Offset",
			"Hash": "Sample-Create-Offset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.RepresentedQuantity":
		{
			"Name": "Represented Quantity",
			"Hash": "Sample-Create-RepresentedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.SampledQuantity":
		{
			"Name": "Sampled Quantity",
			"Hash": "Sample-Create-SampledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.SampledQuantityUnits":
		{
			"Name": "Sampled Quantity Units",
			"Hash": "Sample-Create-SampledQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.RepresentedQuantityUnits":
		{
			"Name": "Represented Quantity Units",
			"Hash": "Sample-Create-RepresentedQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Units":
		{
			"Name": "Units",
			"Hash": "Sample-Create-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.RequestedBy":
		{
			"Name": "Requested By",
			"Hash": "Sample-Create-RequestedBy",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.IDSampleType":
		{
			"Name": "Sample Type",
			"Hash": "Sample-Create-IDSampleType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "SampleType",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"SampleDetails.IDProduct":
		{
			"Name": "Product",
			"Hash": "Sample-Create-IDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "Product",
				"SearchFields":
				[
					"Name",
					"ManufacturerCode",
					"CatalogCode"
				]
			}
		},
		"SampleDetails.SampledByIDUser":
		{
			"Name": "Sampled By IDUser",
			"Hash": "Sample-Create-SampledByIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.WitnessIDUser":
		{
			"Name": "Witness IDUser",
			"Hash": "Sample-Create-WitnessIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.AuthorizedIDUser":
		{
			"Name": "Authorized IDUser",
			"Hash": "Sample-Create-AuthorizedIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.CMSIDUser":
		{
			"Name": "CMSIDUser",
			"Hash": "Sample-Create-CMSIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Datum":
		{
			"Name": "Datum",
			"Hash": "Sample-Create-Datum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Locked":
		{
			"Name": "Locked",
			"Hash": "Sample-Create-Locked",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "15",
				"Width": 3,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Sequenced":
		{
			"Name": "Sequenced",
			"Hash": "Sample-Create-Sequenced",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "16",
				"Width": 3,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Sample-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Sample-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Sample-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Sample-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
